import { f as o } from "./index773.mjs";
import { a as e } from "./index777.mjs";
import { a as i } from "./index828.mjs";
import { t as l } from "./index838.mjs";
import { g as n } from "./index856.mjs";
var f = o, m = e, p = i, s = l, v = n, g = TypeError, T = function(r, a) {
  var t = arguments.length < 2 ? v(r) : a;
  if (m(t))
    return p(f(t, r));
  throw new g(s(r) + " is not iterable");
};
export {
  T as g
};
